export default __webpack_public_path__ + "static/media/icon_html.a92a549a.png";